// extracted by mini-css-extract-plugin
module.exports = {"productDescription":"ProductDetailDescription_productDescription_16ryZ"};